import {useState} from 'react'

const LoginInput = ({value, onChange, type = "text", label}) => {
    const [isFocused, setIsFocused] = useState(false);
    return (
        <div className={`w-100 login-input ${isFocused || !!value ? 'focused' : ''}`}>
            <label>{label}</label>
            <input type={type} aria-label={label} value={value} onChange={onChange} onFocus={() => setIsFocused(true)} onBlur={() => setIsFocused(false)} />
            <fieldset>
                <legend>{label}</legend>
            </fieldset>
        </div>
    )
}

export default LoginInput